module.exports = __webpack_public_path__ + "media/images/steps/step_13-48791ce75ab091f19d12fb2f5967056f.svg";